export default "__VITE_ASSET__DYnniI3u__"